import { gtm } from '@services/gtm';
import { luckyOrange } from '@services/luckyOrange';
import { FeatureNames } from '@swyft/ui';
import { useAppContext } from '@utils/appState';
import { useFeature } from '@utils/config';
import { useEffect } from 'react';

export const Analytics = () => {
  const { enabled: featureLOEnabled } = useFeature(FeatureNames.LuckyOrange);
  const {
    state: {
      luckyOrangeSiteId,
      questionnaireAnalytics: { gtmId }
    }
  } = useAppContext();

  // Uncomment below to enable Old Matomo Tracking
  // useEffect(() => {
  //   mtm.initialize();
  // });

  useEffect(() => {
    gtm.initialize({
      containerId: gtmId
    });
  }, [gtmId]);

  useEffect(() => {
    if (!featureLOEnabled) {
      return;
    }
    luckyOrange.initialize({
      containerId: luckyOrangeSiteId as string
    });
  }, [luckyOrangeSiteId, featureLOEnabled]);

  return <></>;
};
